import React from "react";
import styles from "../styles/TermsAndConditions.module.css";

const TermsAndConditions = () => {
  return (
    <main className={styles.termsLayout}>
      <aside className={styles.termsSidebar}>
        <h2>Table of Contents</h2>
        <ul>
          <li>
            <a href="#scope-and-acceptance">1. Scope and Acceptance</a>
          </li>
          <li>
            <a href="#general-terms">PART I: General Terms of Use</a>
          </li>
          <li>
            <a href="#additional-terms">PART II: Additional Terms of Use</a>
          </li>
        </ul>
      </aside>
      <div className={styles.termsContent}>
        <h1>TERMS & CONDITIONS</h1>
        <p className={styles.lastUpdated}>LAST UPDATED: 30 SEPTEMBER 2024</p>

        {/* Section 1: Scope and Acceptance */}
        <section className={styles.section} id="scope-and-acceptance">
          <h2>1. SCOPE AND ACCEPTANCE</h2>
          <div className={styles.subSection}>
            <h3>1.1. SCOPE</h3>
            <p>
              These terms and conditions, composed of Part I (General Terms of
              Use) and Part II (Additional Terms of Use), (collectively, the
              "Terms") govern your use of the following services (collectively,
              the "Services") offered or managed by Coda Payments Pte. Ltd.
              ("Coda Singapore") and/or its affiliates and subsidiaries...
            </p>
            <ul>
              <li>
                (a) The website (www.coda.co), along with access to it and all
                its links and functions;
              </li>
              <li>
                (b) The Codashop mobile application, the Codashop website
                (www.codashop.com), and all other platforms...
              </li>
              <li>
                (c) User accounts registered through Codashop (a "Coda
                Account");
              </li>
            </ul>
          </div>
          <div className={styles.subSection}>
            <h3>1.2. ACCEPTANCE</h3>
            <p>
              By using any of the Services, you consent to and accept these
              Terms and agree to be bound by them. IF YOU DO NOT ACCEPT OR AGREE
              TO THE TERMS, YOU SHOULD IMMEDIATELY STOP USING AND/OR ACCESSING
              THE SERVICES.
            </p>
          </div>
          <div className={styles.subSection}>
            <h3>1.3. AMENDMENTS</h3>
            <p>
              Coda reserves the right to make changes at any time to these Terms
              or any of the policies or notices relating to its platforms, sites
              or applications...
            </p>
          </div>
          <div className={styles.subSection}>
            <h3>1.4. UPDATES</h3>
            <p>
              Coda may provide new features, upgrades, updates, patches, and
              other modifications to the Services (collectively, the
              "variations")...
            </p>
          </div>
        </section>

        {/* Part I: General Terms of Use */}
        <section className={styles.section} id="general-terms">
          <h2>PART I GENERAL TERMS OF USE</h2>

          <div className={styles.subSection}>
            <h3>2. USE OF THE SERVICES</h3>
            <h4>2.1. Application of Terms through use</h4>
            <p>
              These Terms shall apply regardless of how you access or use any of
              the Services, including but not limited to mobile devices, desktop
              devices, mobile applications, internet browsers, or any other
              device, application, or software.
            </p>

            <h4>2.2. License for use</h4>
            <p>
              2.2.1. Coda grants you a non-exclusive, non-transferable, limited
              right and license to access and use the Coda Sites and/or the
              Services for your personal and non-commercial use, subject to
              these Terms.
            </p>
            <p>
              2.2.2. Coda reserves the right to terminate such license without
              prior notice to you, if it is found that your use of the Services
              violates these Terms.
            </p>

            <h4>2.3. Access and use of Services and Coda Sites</h4>
            <p>
              2.3.1. The Services allow you to purchase certain digital content,
              such as gift codes, app/game credits, and vouchers from Coda or
              its Publishers via the Coda Sites or through the Publishers’ sites
              or platforms, and make payment for such purchases through the
              Payment Channels by:
            </p>
            <ul>
              <li>
                (i) Redeeming or consuming prepaid mobile credits issued by your
                mobile network operator;
              </li>
              <li>
                (ii) Having the value of such purchase added to your postpaid
                mobile bill issued by your mobile network operator; or
              </li>
              <li>
                (iii) Using one of the other payment options offered by Coda’s
                payment channel partners, such as e-wallets, voucher
                redemptions, over-the-counter payments at participating
                convenience stores, credit cards, and bank transfers.
              </li>
            </ul>
            <p>
              For credit card or bank transfer payments, any banking or credit
              card details that you provide are collected directly by the
              Payment Channels who are the relevant banking institutions, card
              issuers, or card aggregators. These details are not collected,
              stored, or processed by Coda.
            </p>
            <p>
              2.3.2. Purchases made using the Services will be in one of two
              forms, where:
            </p>
            <ul>
              <li>
                (a) You purchase gift codes, in-app/game credits, and vouchers
                directly from third-party Publishers (“Publisher Codes”) as the
                merchant on record, and Coda provides facilitation services to
                the Publishers by processing and collecting payments for the
                purchased Publisher Codes for and on the Publishers’ behalf;
              </li>
              <li>
                (b) Coda resells the Publisher Codes directly to you, as the
                merchant on record.
              </li>
            </ul>

            <h4>
              2.4. Payment facilitation and digital content reselling services
            </h4>
            <p>
              2.4.1. You initiate and make a purchase by choosing to purchase
              Publisher Codes via (i) the relevant Publisher’s site or mobile
              platform, where you will be routed to the Coda Sites to make
              payment; or (ii) Codashop.
            </p>
            <p>
              2.4.2. To make payments via the Services, you must have a valid
              and eligible mobile phone account with one of our partner mobile
              network operators or a valid payment instrument issued or
              recognised by the Payment Channels.
            </p>
            <p>
              2.4.3. You are fully liable for the use of your payment accounts
              or instruments via the Services. You acknowledge and accept that
              Coda has no liability for any unauthorised use or access by third
              persons of your accounts or your payment instruments.
            </p>
            <p>
              2.4.4. Coda, the Publishers, and/or the Payment Channels reserve
              the right and discretion to reject or decline any transaction for
              any reason or set limits on transaction types and/or amounts.
            </p>

            <h4>2.5. Publisher Codes</h4>
            <p>
              In respect of Publisher Codes purchased through any of the Coda
              Sites or using any of the Services, the relevant Publishers that
              issued the purchased Codes, and not Coda, are solely responsible
              for redeeming the Codes, and for providing goods or services to
              you in exchange. Unless otherwise noted on the relevant product
              information page on the Coda Sites, Publisher Codes do not expire.
            </p>

            <h4>2.6. Modification of Services</h4>
            <p>
              Coda reserves the right to change, modify, suspend or discontinue
              the Services in part or whole at any time, with or without notice
              to you. Any changes or modifications may be reflected in these
              Terms according to the section on Amendments.
            </p>

            <h4>2.7. Taxes, charges, and fees</h4>
            <p>
              You are responsible for any taxes, duties, currency exchange fees,
              data charges, and related charges on purchases that you make as a
              result of or in the course of using any of the Coda Sites or
              Services.
            </p>

            <h4>2.8. Disputes handling</h4>
            <p>
              If you are dissatisfied with any Publisher Codes purchased using
              the Services, or if you believe that you have been charged in
              error, please directly contact the following in order to resolve
              the issue:
            </p>
            <ul>
              <li>(a) Coda, for purchases made on Codashop; or</li>
              <li>(b) the Publisher, for all other transactions.</li>
            </ul>
            <p>
              If you are unable to resolve the issue with the Publisher
              directly, you may file a dispute or complaint against the
              Publisher with us. You must not make any false or misleading
              statements when filing, or during the subsequent investigation of,
              a dispute. Coda will investigate all disputes that are filed with
              it and will make reasonable efforts to resolve them. However, the
              ultimate resolution of such disputes shall be at Coda’s sole
              discretion.
            </p>

            <h4>2.9. Error handling</h4>
            <p>
              As part of or separate from the dispute handling process, Coda may
              determine that a mistake has been made that affects you. If Coda
              determines that you have been incorrectly charged or overcharged,
              Coda will credit your account or otherwise arrange for a refund to
              rectify the mistake. If Coda concludes that you were not charged
              when you ought to have been, or that you have been undercharged,
              Coda may debit or charge your account or otherwise collect a
              payment to rectify the mistake accordingly.
            </p>
          </div>

          <div className={styles.subSection}>
            <h3>3. CONSUMER PROTECTION</h3>
            <h4>3.1. Product Descriptions</h4>
            <p>
              Coda takes every effort to ensure that the product descriptions on
              Codashop are as accurate as possible. However, to the extent
              permitted by law, we do not warrant that such product descriptions
              are complete and accurate.
            </p>

            <h4>3.2. Refunds</h4>
            <p>
              You acknowledge and understand that transactions successfully made
              using any of the Coda Sites or Services are final. No returns will
              be accepted, and no refunds will be issued unless expressly
              specified otherwise in these Terms. In the event that a refund
              will be made to you after dispute and/or error handling as
              outlined in the sections on Disputes and Error Handling, the time
              frame to credit the refund to your bank or payment service account
              shall depend on the Payment Channel used or your bank or payment
              service provider.
            </p>
          </div>
        </section>

        {/* Part II: Additional Terms of Use */}
        <section className={styles.section} id="additional-terms">
          <h2>PART II ADDITIONAL TERMS OF USE</h2>
          <div className={styles.subSection}>
            <h3>ADDITIONAL TERMS OF USE FOR CODACASH</h3>
            <p>
              1. Scope and applicability. The provisions under this Section (the
              "Codacash Terms") apply to all services related to Codacash...
            </p>
            <h4>2. Availability</h4>
            <p>
              Codacash is a closed loop e-wallet system only available to
              residents of the following countries (the "Codacash
              Territories")...
            </p>
            <table>
              <thead>
                <tr>
                  <th>Country/Region</th>
                  <th>Codacash Issuer</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Indonesia</td>
                  <td>
                    PT Coda Indonesia in partnership with PT Nusa Satu Inti
                    Artha (Doku)
                  </td>
                </tr>
                <tr>
                  <td>Korea</td>
                  <td>Coda Payments Korea Ltd.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Add more sections as needed */}
      </div>
    </main>
  );
};

export default TermsAndConditions;
